import { Body, Box, BoxProps } from '@hover/blueprint';
import React, { Dispatch, FC, SetStateAction } from 'react';

interface Props extends BoxProps {
  prevPageNumber: number | null;
  setPageNumber: Dispatch<SetStateAction<number>>;
  currentPageNumber: number;
  nextPageNumber: number | null;
}

const PaginationPagesDesktop: FC<Props> = props => {
  const { prevPageNumber, setPageNumber, currentPageNumber, nextPageNumber } =
    props;

  return (
    <Box mx={200} display={{ base: 'none', tablet: 'flex' }} px={500}>
      {prevPageNumber ? (
        <Body
          as="button"
          size={600}
          mx={300}
          onClick={() => {
            setPageNumber(prevPageNumber);
          }}
        >
          {prevPageNumber}
        </Body>
      ) : null}
      <Body
        as="button"
        size={600}
        mx={300}
        color="primary.600"
        onClick={() => {
          setPageNumber(currentPageNumber);
        }}
      >
        {currentPageNumber}
      </Body>
      {nextPageNumber ? (
        <Body
          as="button"
          size={600}
          mx={300}
          onClick={() => {
            setPageNumber(nextPageNumber);
          }}
        >
          {nextPageNumber}
        </Body>
      ) : null}
    </Box>
  );
};

export default PaginationPagesDesktop;
